import LiveFeedback, { useLiveNotice } from './LiveFeedback';
import TaxExemptCheckbox from '../../../../Component/UI/TaxExemptCheckbox';
import LiveToolbarIcon from "./LiveToolbarIcon";
import { LiveCaptureSource } from "../captureLiveImage";
import { createPortal } from "react-dom";
import { useEffect, useRef, useState } from "react";
import { useLiveCaptureWindow } from '../useLiveCaptureWindow';
import ProductCaptureModal from "../Modal/ProductCaptureModal";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import { fontStyles } from "../../../../Component/style/admin_font";
import { AdminIcon as Icon, RowView, CenterView } from "../../../../Component/style/common_style";
import ProductDescriptionModal from "../Modal/ProductDescriptionModal";
import { productRequestError } from "../productRequestError";
import { directUploadFiles, DirectUploadResult, PRODUCT_CREATE_DIRECT_URL } from "../../../../Component/tool/directUpload";

const Detail_itemInsert = (props: {
  updateChnage: () => void;
  inline?: boolean;
  warehouse?: boolean;
  onBusyChange?: (busy: boolean) => void;
  onRegistered?: () => void;
  live_finish?: string;
  captureImage?: () => Promise<File>;
  getLiveVideo?: () => LiveCaptureSource | null;
  onCaptureModeChange?: (selecting: boolean) => void;
}) => {
  const notifyLive = useLiveNotice();
  const { seq } = useParams();
  const updateChnage = props.updateChnage;
  const { captureTarget, captureWindowError, openCapture, closeCapture } = useLiveCaptureWindow(seq);
  const hadCaptureWindow = useRef(false);
  useEffect(() => {
    if (!props.inline) return;
    if (captureTarget) { hadCaptureWindow.current = true; return; }
    if (hadCaptureWindow.current || captureWindowError) {
      hadCaptureWindow.current = false; setCaptureOpen(false); setCapturing(false); capturingRef.current = false;
    }
  }, [props.inline, captureTarget, captureWindowError]);
  const [product_num, setProduct_num] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState<number | null>(null);
  const [init_cnt, setInit_cnt] = useState<number | null>(1);
  const [description, setDescription] = useState("");
  const [isTaxExempt, setIsTaxExempt] = useState(false);
  const [individualDelivery, setIndividualDelivery] = useState(false);
  const [individualDeliveryPrice, setIndividualDeliveryPrice] = useState('0');
  const [descModalOpen, setDescModalOpen] = useState(false);

  const [images, setImages] = useState<File[]>([]);
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const productCodeRef = useRef<HTMLInputElement>(null);
  const savingRef = useRef(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { props.onBusyChange?.(saving); }, [saving, props.onBusyChange]);
  const [registrationError, setRegistrationError] = useState("");
  const [capturing, setCapturing] = useState(false);
  const capturingRef = useRef(false);
  const [captureOpen, setCaptureOpen] = useState(false);
  const captureRequest = useRef(0);
  const imageUrls = useRef<string[]>([]);
  const uploadAbort = useRef<AbortController | null>(null);
  const pendingUpload = useRef<DirectUploadResult | null>(null);
  const idempotencyKey = useRef<string | null>(null);

  const invalidatePendingRequest = () => {
    pendingUpload.current = null;
    idempotencyKey.current = null;
  };

  useEffect(() => () => {
    captureRequest.current++;
    uploadAbort.current?.abort();
    imageUrls.current.forEach(value => URL.revokeObjectURL(value));
  }, []);

  const finishCapture = (file: File | null) => {
    if (file) {
      const preview = URL.createObjectURL(file);
      imageUrls.current.push(preview);
      invalidatePendingRequest();
      setImages(previous => [file, ...previous]);
      setImagePreviews(previous => [preview, ...previous]);
    }
    closeCapture();
    setCaptureOpen(false);
    capturingRef.current = false;
    setCapturing(false);
    props.onCaptureModeChange?.(false);
  };

  const capturePhoto = () => {
    if (!props.captureImage || savingRef.current || capturingRef.current || images.length >= 10) return;
    if (props.inline) openCapture(props.getLiveVideo?.()?.ownerDocument ?? document);
    capturingRef.current = true;
    setCapturing(true);
    setCaptureOpen(true);
    props.onCaptureModeChange?.(true);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (savingRef.current || capturingRef.current) return;
    const files = e.target.files;
    if (!files) return;

    const newImages = Array.from(files);
    if (images.length + newImages.length > 10) {
      notifyLive("사진은 최대 10개까지 등록 가능합니다.");
      return;
    }

    const updatedImages = [...images, ...newImages];
    invalidatePendingRequest();
    setImages(updatedImages);

    const newPreviews = newImages.map((file) => URL.createObjectURL(file));
    imageUrls.current.push(...newPreviews);
    setImagePreviews([...imagePreviews, ...newPreviews]);
  };

  const removeImage = (idx: number) => {
    if (savingRef.current || capturingRef.current) return;
    URL.revokeObjectURL(imagePreviews[idx]);
    imageUrls.current = imageUrls.current.filter(value => value !== imagePreviews[idx]);
    const updatedImages = images.filter((_, i) => i !== idx);
    invalidatePendingRequest();
    setImages(updatedImages);

    const updatedPreviews = imagePreviews.filter((_, i) => i !== idx);
    setImagePreviews(updatedPreviews);
  };

  const setting_pnum = (e: React.ChangeEvent<HTMLInputElement>) => {
    invalidatePendingRequest();
    setProduct_num(e.target.value);
  };
  const setting_name = (e: React.ChangeEvent<HTMLInputElement>) => {
    invalidatePendingRequest();
    setName(e.target.value);
  };
  const setting_price = (e: React.ChangeEvent<HTMLInputElement>) => {
    invalidatePendingRequest();
    setPrice(Number(e.target.value));
  };
  const setting_init_cnt = (e: React.ChangeEvent<HTMLInputElement>) => {
    invalidatePendingRequest();
    setInit_cnt(Number(e.target.value));
  };
  const insert_product = async () => {
    if (savingRef.current || capturingRef.current) return;
    if (name.trim() === "" || price === null || init_cnt === null) {
      notifyLive("상품정보를 정확히 입력해주세요.");
      return;
    }
    const deliveryPrice = individualDelivery ? Number(individualDeliveryPrice) : 0;
    if (!Number.isSafeInteger(deliveryPrice) || deliveryPrice < 0 || deliveryPrice > 2147483647) {
      setRegistrationError('개별배송비는 0원 이상의 정수로 입력해주세요.');
      return;
    }

    savingRef.current = true;
    setSaving(true);
    setRegistrationError("");
    try {
      const liveSeq = props.warehouse ? 0 : Number(seq);
      if (!Number.isInteger(liveSeq) || (!props.warehouse && liveSeq < 1)) throw new Error("방송 정보를 확인해주세요.");
      uploadAbort.current = new AbortController();
      if (images.length && !pendingUpload.current) {
        pendingUpload.current = await directUploadFiles(images, {
          purpose: props.warehouse ? "warehouse-image" : "product-image",
          liveSeq,
          signal: uploadAbort.current.signal,
        });
      }
      idempotencyKey.current ??= crypto.randomUUID();
      const uploaded = pendingUpload.current;
      const res = await api.post(PRODUCT_CREATE_DIRECT_URL, {
        live_seq: liveSeq,
        ...(product_num.trim() ? { product_num: product_num.trim() } : {}),
        name: name.trim(),
        price,
        init_cnt,
        is_tax_exempt: isTaxExempt,
        individual_delivery: individualDelivery,
        individual_delivery_price: deliveryPrice,
        product_description: description || " ",
        idempotencyKey: idempotencyKey.current,
        ...(uploaded ? {
          uploadSessionId: uploaded.sessionId,
          imageObjectIds: uploaded.objects.map(object => object.objectId),
        } : { imageObjectIds: [] }),
      }, { headers: { "Content-Type": "application/json" }, signal: uploadAbort.current.signal });

      if (res.data?.status !== "completed" || !Number.isInteger(res.data?.productSeq)) {
        throw new Error("상품을 등록하지 못했습니다. 다시 시도해주세요.");
      }
      setProduct_num("");
      setName("");
      setPrice(null);
      setInit_cnt(1);
      setDescription("");
      setIsTaxExempt(false); setIndividualDelivery(false);
      setIndividualDeliveryPrice('0');
      setImages([]);
      imageUrls.current.forEach(value => URL.revokeObjectURL(value));
      imageUrls.current = [];
      setImagePreviews([]);
      pendingUpload.current = null;
      idempotencyKey.current = null;
      updateChnage();
      props.onRegistered?.();
      if (props.inline) window.requestAnimationFrame(() => productCodeRef.current?.focus());
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      setRegistrationError(productRequestError(error, "상품 등록에 실패했습니다. 다시 시도해주세요."));
    } finally {
      uploadAbort.current = null;
      savingRef.current = false;
      setSaving(false);
    }
  };

  return (
    <>
      {captureOpen && props.captureImage && (!props.inline || captureTarget) && createPortal(<ProductCaptureModal liveSeq={Number(seq)}
        captureImage={props.captureImage} getLiveVideo={props.getLiveVideo}
        portalTarget={props.inline ? captureTarget : undefined}
        onCaptured={finishCapture} onClose={() => finishCapture(null)} />, props.inline ? captureTarget! : document.body)}
      <InsertForm data-admin-modal-content={!props.inline ? "" : undefined} $inline={props.inline} onKeyDown={event => {
        const target = event.target as HTMLInputElement;
        if (props.inline && event.key === 'Enter' && !event.nativeEvent.isComposing && event.nativeEvent.keyCode !== 229 && target.tagName === 'INPUT' && ['text', 'number'].includes(target.type)) {
          event.preventDefault(); void insert_product();
        }
      }}><div className="registration-fields" data-admin-modal-body={!props.inline ? "" : undefined}>
      {props.inline && <RegistrationHeading><h3>상품 바로 등록</h3><AddProductBtn type="button" disabled={saving || capturing} onClick={insert_product}><LiveToolbarIcon name="plus" />{saving ? "등록 중..." : "상품 등록"}</AddProductBtn></RegistrationHeading>}
      <InsertItem className="bottom">
        <div style={{ maxWidth: "10rem" }}>
          <div>상품코드</div>
          <InputBox
            type="text"
            ref={productCodeRef}
            aria-label="상품코드"
            disabled={saving || capturing}
            placeholder="예: SKU-001"
            maxLength={255}
            value={product_num}
            onChange={setting_pnum}
          />
        </div>
        <div>
          <div>상품명</div>
          <InputBox aria-label="상품명" disabled={saving || capturing} placeholder="-" value={name} onChange={setting_name} />
        </div>
        <div style={{ maxWidth: "8rem" }}>
          <div>가격</div>
          <InputBox
            type={"number"}
            aria-label="가격"
            disabled={saving || capturing}
            placeholder="-"
            value={price ?? ""}
            onChange={setting_price}
          />
        </div>
        <div style={{ maxWidth: "8rem" }}>
          <div>재고</div>
          <InputBox
            type={"number"}
            aria-label="재고"
            disabled={saving || capturing}
            placeholder="-"
            value={init_cnt ?? ""}
            onChange={setting_init_cnt}
          />
        </div>
        {!props.inline && <div style={{ maxWidth: "8rem" }}>
          <div>상품설명</div>
          <WriteDescBtn type="button" disabled={saving || capturing} onClick={() => setDescModalOpen(true)}>
            {description ? "작성완료" : "작성하기"}
          </WriteDescBtn>
        </div>}
      </InsertItem>

      <RegistrationDelivery $inline={props.inline}>
        <TaxExemptCheckbox label="면세 여부" checked={isTaxExempt} disabled={saving || capturing}
          onChange={checked => { invalidatePendingRequest(); setIsTaxExempt(checked); }} />
        <DeliveryToggle type="button" aria-pressed={individualDelivery} disabled={saving || capturing}
          onClick={() => { invalidatePendingRequest(); setIndividualDelivery(value => !value); }}>개별 배송</DeliveryToggle>
        {individualDelivery && <label>개별 배송비<InputBox type="number" aria-label="개별 배송비" min={0} max={2147483647} step={1}
          value={individualDeliveryPrice} disabled={saving || capturing}
          onChange={event => { invalidatePendingRequest(); setIndividualDeliveryPrice(event.target.value); }} />원</label>}
        {props.inline && <>
          <CapturePhotoButton type="button" disabled={saving || capturing || images.length >= 10} onClick={() => fileInputRef.current?.click()}><LiveToolbarIcon name="image" />사진 첨부</CapturePhotoButton>
          {props.captureImage && <CapturePhotoButton type="button" disabled={saving || capturing || images.length >= 10} onClick={capturePhoto}><LiveToolbarIcon name="camera" />{capturing ? '캡처 중...' : '방송 화면 캡처'}</CapturePhotoButton>}
        </>}
      </RegistrationDelivery>

      <PhotoUploadSection $inline={props.inline} $empty={!images.length}>
        <PhotoLabel>사진 ({images.length}/10)</PhotoLabel>
        {!props.inline && props.captureImage && <CapturePhotoButton type="button" disabled={saving || capturing || images.length >= 10} onClick={capturePhoto}>{capturing ? '캡처 중...' : '방송 화면 캡처'}</CapturePhotoButton>}
        <PhotoContainer>
          {imagePreviews.map((preview, idx) => (
            <PhotoPreviewBox key={idx}>
              <img src={preview} alt={`preview-${idx}`} />
              <DeletePhotoBtn type="button" disabled={saving || capturing} aria-label={`${idx + 1}번째 사진 삭제`} onClick={() => removeImage(idx)}>
                <Icon aria-hidden="true" src={require("../../../../Image/ic_x_circle_white.png")} style={{ width: "1.2rem", height: "1.2rem" }} />
              </DeletePhotoBtn>
            </PhotoPreviewBox>
          ))}
          {!props.inline && images.length < 10 && (
            <AddPhotoBox type="button" disabled={saving || capturing} aria-label="상품 사진 추가" onClick={() => fileInputRef.current?.click()}>
              <Icon aria-hidden="true" src={require("../../../../Image/ic_plus_gray.png")} style={{ width: "2rem", height: "2rem" }} />
            </AddPhotoBox>
          )}
        </PhotoContainer>
        <input
          type="file"
          disabled={saving || capturing}
          ref={fileInputRef}
          onChange={handleImageChange}
          multiple
          accept="image/*"
          style={{ display: "none" }}
        />
      </PhotoUploadSection>

      </div><RegistrationFooter data-admin-modal-footer={!props.inline ? "" : undefined} $inline={props.inline} data-testid="product-registration-footer">
        {(registrationError || (props.inline && captureWindowError)) && <LiveFeedback role="alert">{registrationError || captureWindowError}</LiveFeedback>}
        {!props.inline && <AddProductBtn type="button" disabled={saving || capturing} onClick={insert_product}>{saving ? "등록 중..." : "상품 등록"}</AddProductBtn>}
      </RegistrationFooter>

      {/* 상품설명 작성 모달 */}
      <ProductDescriptionModal
        visible={descModalOpen}
        onClose={() => setDescModalOpen(false)}
        description={description}
        onSave={(updatedDesc) => { invalidatePendingRequest(); setDescription(updatedDesc); }}
      />
      </InsertForm>
    </>
  );
};
export default Detail_itemInsert;

const RegistrationHeading = styled.header`
  display: flex; align-items: center; justify-content: space-between; gap: var(--space-3); margin-bottom: var(--space-2);
  h3 { margin: 0; font-size: var(--text-h3); font-weight: 600; color: var(--color-text-primary); }
  button { display: inline-flex; align-items: center; gap: var(--space-2); margin: 0; min-height: var(--control-md); height: var(--control-md); padding: 0 var(--space-4); border-radius: var(--radius-md); font-size: var(--text-body); }
`;

const DeliveryToggle = styled.button`
  display:inline-flex;align-items:center;justify-content:center;min-height:var(--control-md);padding:0 var(--space-4);
  border:1px solid var(--color-border-default);border-radius:var(--radius-md);background:var(--color-bg-surface);color:var(--color-text-primary);font:inherit;cursor:pointer;
  &[aria-pressed="true"]{border-color:var(--color-brand);background:var(--color-brand-subtle);color:var(--color-text-link);}
  &:disabled{background:var(--color-bg-muted);color:var(--color-text-disabled);cursor:default;}
  &:focus-visible{outline:2px solid var(--color-focus-ring);outline-offset:2px;}
`;
const RegistrationDelivery = styled.section<{ $inline?: boolean }>`
  display: flex; align-items: center; flex-wrap: wrap; gap: var(--space-3);
  margin-bottom: var(--space-2); color: var(--color-text-primary); font-size: var(--text-body);
  label { display: inline-flex; align-items: center; gap: var(--space-2); }
  input[type="checkbox"] { accent-color: var(--color-brand); }
  input[type="number"] { width: calc(var(--control-md) * 4); min-height: var(--control-md); margin: 0; padding: 0 var(--space-2); }
  ${props => props.$inline && `
    flex-wrap: nowrap; overflow-x: auto;
    > label, > button { flex: none; white-space: nowrap; }
    > button { display: inline-flex; align-items: center; gap: var(--space-2); min-height: var(--control-md); height: var(--control-md); margin: 0; font-size: var(--text-body); }
  `}
`;

const InsertForm = styled.div<{ $inline?: boolean }>`
  > .registration-fields { display: contents; }
  ${props => props.$inline && `
    min-height: 0 !important;
    > .registration-fields > div.bottom { flex-wrap: wrap; gap: var(--space-2) var(--space-3); margin-bottom: var(--space-2); }
    > .registration-fields > div.bottom > div { flex: 1 1 120px; min-width: 0; }
    > .registration-fields > div.bottom > div > div { margin-bottom: var(--space-1); }
    > .registration-fields > section { margin-bottom: 0; }
  `}
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const RegistrationFooter = styled.footer<{ $inline?: boolean }>`
  position: sticky;
  bottom: -28px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin: auto -28px -28px;
  padding: 20px 28px;
  border-top: 1px solid var(--admin-theme-border, #ebe8f1);
  background: var(--admin-theme-surface, #fff);

  p { flex: 1; margin: 0; color: var(--admin-danger, #d92d4a); }

  @media (max-width: 720px) {
    bottom: -20px;
    margin: auto -20px -20px;
    padding: 16px 20px;
  }
  ${props => props.$inline && `
    && { position: static; margin: 0; padding: 0; border: 0; background: transparent; }
    &:empty { display: none; }
  `}

`;

const CapturePhotoButton = styled.button`
  align-self: flex-start;
  min-height: 44px;
  margin-bottom: 0.8rem;
  padding: 10px 16px;
  border: 1px solid var(--admin-theme-border, #ddd8e7);
  border-radius: 8px;
  background: var(--admin-theme-surface, #fff);
  color: var(--admin-theme-link, #5730c4);
  font: inherit;
  cursor: pointer;
  &:hover:not(:disabled) { background: var(--admin-theme-raised, #faf8ff); border-color: #8464dd; }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
  &:disabled { opacity: 0.55; cursor: not-allowed; }
`;

const WriteDescBtn = styled.button`
  box-sizing: border-box;
  margin-top: 0.5rem;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--admin-accent-deep);
  border-radius: 8px;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-theme-link, var(--admin-accent-deep));
  font-size: 15px;
  cursor: pointer;
  ${fontStyles.medium}
  &:hover {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;

const AddProductBtn = styled.button`
  border: 0;
  &:disabled { opacity: 0.6; cursor: wait; }
  padding: 0.8rem 1rem;
  white-space: nowrap;
  ${fontStyles.semiBold}
  color: white;
  background-color: var(--admin-solid, #292433);
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
`;

const ModalOverlay = styled(CenterView)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const ModalContent = styled.div`
  box-sizing: border-box;
  width: 90%;
  max-width: 30rem;
  background-color: var(--admin-theme-surface, white);
  border-radius: 8px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled(RowView)`
  justify-content: space-between;
  font-size: 18px;
  ${fontStyles.Bold}
  color: var(--admin-ink);
  margin-bottom: 1rem;
  align-items: center;
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  div.empty {
    color: var(--admin-muted);
    text-align: center;
    padding: 2rem 0;
  }
`;

const LastLiveItemRow = styled.div`
  padding: 0.8rem 1rem;
  border-bottom: 1px solid var(--admin-theme-border, #f0f0f0);
  cursor: pointer;
  font-size: 15px;
  color: var(--admin-ink);
  &:hover {
    background-color: var(--admin-theme-raised, #f8f8f8);
  }
  &:last-child {
    border-bottom: 0;
  }
`;

const DescriptionTextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  height: 12rem;
  padding: 1rem;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  font-size: 15px;
  resize: none;
  outline: 0;
  ${fontStyles.regular}
  &:hover, &:focus {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;

const SaveDescBtn = styled.div`
  padding: 0.6rem 1.5rem;
  background-color: var(--admin-solid, #292433);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  ${fontStyles.semiBold}
  font-size: 15px;
`;

const InsertItem = styled(RowView)`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  div {
    flex: 1;
    margin-right: 0.5rem;
  }
  input {
    margin-top: 0.5rem;
  }
`;

const InputBox = styled.input`
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  padding: 0.8rem;
  ${fontStyles.regular}
  font-size: 16px;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
  &::placeholder {
    color: var(--admin-muted);
  }
  &.search {
    min-width: 20rem;
  }
`;

const PhotoUploadSection = styled.div<{ $inline?: boolean; $empty?: boolean }>`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  ${props => props.$inline && `
    && { margin: 0; ${props.$empty ? 'display: none;' : ''} }
    > div { margin-block: var(--space-2); }
    > div > div { width: 64px; height: 64px; }
  `}

`;

const PhotoLabel = styled.div`
  font-size: 14px;
  color: var(--admin-muted);
  margin-bottom: 0.8rem;
  ${fontStyles.medium}
`;

const PhotoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: center;
`;

const AddPhotoBox = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.5rem;
  height: 5.5rem;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  background-color: var(--admin-theme-surface, #FBFBFB);
  cursor: pointer;
  transition: border 0.2s;
  &:hover {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;

const PhotoPreviewBox = styled.div`
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;

const DeletePhotoBtn = styled.button`
  position: absolute;
  top: -0.3rem;
  right: -0.3rem;
  width: 1.2rem;
  height: 1.2rem;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    background-color: rgba(235, 0, 59, 0.8);
  }
`;
